import { render, staticRenderFns } from "./BillParcel.vue?vue&type=template&id=0e638cf2"
import script from "./BillParcel.vue?vue&type=script&lang=js"
export * from "./BillParcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports